import { MenuItemType } from './enums/MenuItemType';

export class MenuItem {
    public id: string;
    public menuItemType: MenuItemType;
    public displayName: string;
    public iconPath: string;
    public url?: string;
    public triggerFor?: string;
    public selected = false;
    public processLogic: (() => void) | null;
    public onClickEvent: (() => void) | null;

    constructor(
        id: string,
        menuItemType: MenuItemType,
        displayName: string,
        iconPath: string,
        url?: string,
        triggerFor?: string,
        processLogic: (() => void) | null = null,
        onClickEvent: (() => void) | null = null,
    ) {
        this.id = id;
        this.menuItemType = menuItemType;
        this.displayName = displayName;
        this.iconPath = iconPath;
        this.url = url;
        this.triggerFor = triggerFor;
        this.processLogic = processLogic;
        this.onClickEvent = onClickEvent;
    }

    public process(): void {
        if (this.processLogic != null) {
            this.processLogic();
        }
    }
}
